import React,{useState, useEffect} from "react";
import { Link,useParams } from "react-router-dom";
import { var_api } from "../../constant";
import sage from "../../../images/splash/sage.jpeg";
import Nav from 'react-bootstrap/Nav';
import {Navbar,NavDropdown} from 'react-bootstrap';
// import '../Banner/Banner.css';
import './categories.css';
import axios from "axios";
import 'bootstrap-icons/font/bootstrap-icons.css';
import Swal from "sweetalert2";
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Tooltip } from "reactstrap";
import all from '../../../images/sb-images/detoxi.webp';
import hairtre from '../../../images/sb-images/sage sig.webp';
import other from '../../../images/sb-images/scla.webp';
import facial from '../../../images/sb-images/fruit.webp';
import { Button,Form} from 'react-bootstrap';
import { useHistory } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import Loader from "../Loader";


toast.configure()


function ServiceCategory(){
    const [cart, setCart] = useState([]);
    const [images, setImages] = useState([]);
    const [search, setSearch] = useState('');
    const shopName= localStorage.getItem('shopName');
    // const getQuery = event => setSearchQuery(event.target.value);
    const [users, setUsers] = useState([]); 
    const [puttooltipOpen, setPutToolTipOpen] = useState([]);
  const [category, setCategory] = useState([]);
   const [totalItems, setTotalItems] = useState(0);
  const [startIndex, setStartIndex] = useState(0);
  const [ searchQuery,setSearchQuery] = useState('');
  const history = useHistory();
  const [categories, setCategories] = useState([]);
  const [isLogin, setIsLogin] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [show, setShow] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState(null);
  const itemsPerPage = 10;
    console.log(shopName);

    const handleSearchChange = (event) => {
      const newSearch = event.target.value;
      setSearch(newSearch)
      // setQuerySearch(newSearch);
      // onSearchChange(newSearch);
    }

    // Function to convert string to camelCase
  const capitalizeEachWord = (str) => {
    return str.toLowerCase().replace(/(^|\s)\S/g, function (match) {
      return match.toUpperCase();
    });
  };

    const showSuccessAlert = () => {
      Swal.fire({
        title: 'Success',
        text: 'Profile updated successfully!',
        icon: 'success',
        confirmButtonColor: '#007500', // Set the custom color for the Confirm button
      });
    };
  
    const showFailureAlert = () => {
      Swal.fire({
        title: 'Success',
        text: 'Failed to update profile. Please try again.',
        icon: 'success',
        confirmButtonColor: '#007500', // Set the custom color for the Confirm button
      });
    };

    useEffect(() => {
      fetchData();
    }, [currentPage]);

      const handleAdd = async()=>{
        const { value: formValues } = await Swal.fire({
          title: 'Create Category',
          html:
            '<label class="swalLa">Category Name</label>'+
            '<br/>'+
            '<input id="swal-input1" class="swal2-input fin" placeholder="Category Name">' +
            '<br/>'+
            '<br/>'+
            '<label class="swalLa">Description</label>'+
            '<input id="swal-input2" class="swal2-input fin" placeholder="Description">' +
            '<br/>'+
            '<br/>'+
            '<label class="swalLa">Category Image</label>'+
            '<input id="swal-input3" class="swal2-input fin" placeholder="Select File" type="file">',
          focusConfirm: false,
          confirmButtonColor: '#007500',
          confirmButtonText: 'Submit',
          showCancelButton: true,
          cancelButtonColor: '#ff0000', 
          preConfirm: () => {
            const input1 = document.getElementById('swal-input1').value;
            const input2 = document.getElementById('swal-input2').value;
            const input3 = document.getElementById('swal-input3').files[0];
  
            if (!input1 || !input2 ) {
              Swal.showValidationMessage('Please fill in all the required fields');
            } else {
              return [input1, input2, input3];
            }
          }
        })
        
        if (formValues) {
        const [ categoryName, categoryCode, selectedFile ] = formValues;
        const token = localStorage.getItem('token');
        const shopId =  localStorage.getItem('shopId')
        console.log("categoryName",categoryName);
        const camelCaseCategoryName = capitalizeEachWord(categoryName);
        console.log("camelCaseCategoryName",camelCaseCategoryName);
         // Create a FormData object to send the file
         const formData = new FormData();
         formData.append('category_name', camelCaseCategoryName);
         formData.append('description', categoryCode);
         formData.append('category_image', selectedFile);
  
        try { 
    
        // Send the order data to the Node.js API using axios
          const response = await fetch(`${var_api}/api/category-master/post`, {
            method: 'POST',
          body: formData,
          headers: {
            'Authorization': `${token}`
        }
        });
        const data = await response.json();
          if (response.status === 200) {
            fetchData();
            // Handle successful order submission to both databases
            Swal.fire({
              icon: 'success',
              text: 'Category Added Successfully',
              confirmButtonColor: '#007500',
            });
          }else {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: data.error || 'Something went wrong!',
              confirmButtonColor: '#007500',
            });
          }
        } catch (error) {
          console.log("rr",error.response)
          if (error.response && error.response.status === 401) {
            history.push('/signin');
        }else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Something went wrong!',
            confirmButtonColor: '#007500',
          });
        }
          console.error("Error adding document: ", error);
        }
        }
      };



      const handleEdit = async (category) => {
        const { value: formValues } = await Swal.fire({
          title: 'Update Category',
          html:
            `<label class="swalLa">Category Name</label><br/>
            <input id="swal-input1" class="swal2-input fin" placeholder="Category Name" value="${category.category_name}" /><br/><br/>
            <label class="swalLa">Description</label><br/>
            <input id="swal-input2" class="swal2-input fin" placeholder="Description" value="${category.description}" /><br/><br/>
            <label class="swalLa">Category Image</label><br/>
            <input id="swal-input3" class="swal2-input fin" placeholder="Select File" type="file" />`,
          focusConfirm: false,
          confirmButtonColor: '#007500',
          confirmButtonText: 'Update',
          showCancelButton: true,
          cancelButtonColor: '#ff0000',
          preConfirm: () => {
            const input1 = document.getElementById('swal-input1').value;
            const input2 = document.getElementById('swal-input2').value;
            const input3 = document.getElementById('swal-input3').files[0];
    
            if (!input1 || !input2) {
              Swal.showValidationMessage('Please fill in all the required fields');
              return null; // This line ensures the promise chain is broken
            } else {
              return [input1, input2, input3];
            }
          }
        });
    
        if (formValues) {
          const [categoryName, description, selectedFile] = formValues;
          const token = localStorage.getItem('token');
          const camelCaseCategoryName = capitalizeEachWord(categoryName);
    
          const formData = new FormData();
          formData.append('category_name', camelCaseCategoryName);
          formData.append('description', description);
    
          if (selectedFile) {
            formData.append('category_image', selectedFile );
          } else {
            formData.append('category_image', category.category_image);
          }
    
          try {
            const response = await fetch(`${var_api}/api/category-master/put/${category.id}`, {
              method: 'PUT',
              body: formData,
              headers: {
                'Authorization': `${token}`
              }
            });
            const data = await response.json();
    
            if (response.status === 200) {
              fetchData();
              Swal.fire({
                icon: 'success',
                text: 'Category Updated Successfully',
                confirmButtonColor: '#007500',
              });
            }else {
              Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: data.error || 'Something went wrong!',
                confirmButtonColor: '#007500',
              });
            }
          } catch (error) {
            if (error.response && error.response.status === 401) {
              history.push('/signin');
            }else {
              Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Something went wrong!',
                confirmButtonColor: '#007500',
              });
            }
            console.error("Error adding document: ", error);
          }
        }
      };
    
        //get the categories data
        const fetchData = async () => {
          const token = localStorage.getItem('token');
          const startIndexCalc = (currentPage - 1) * itemsPerPage;
          const endIndex = startIndexCalc + itemsPerPage;
          setIsLogin(true);
          try {
            const response = await axios.get(`${var_api}/api/category-master/get`, {
              headers: {
                'Authorization': `${token}`
              }
            });
            const categoryMaster = response.data;
            if (categoryMaster.length > 0) {
              setCategories(categoryMaster);
            } else {
              console.log('No data found.');
              setCategories([]);
            }
            setIsLogin(false);
          } catch (error) {
            console.log('Error fetching data:', error);
            if (error.response && error.response.status === 401) {
              history.push('/signin');
          }
            setCategories([]);
            setIsLogin(false);
          }
        };
        const handleCardClick = (category) => {
          localStorage.setItem('selectedCategoryId', category.id);
          localStorage.setItem('selectedCategoryName', category.category_name);
          // You can perform any additional actions here if needed
        };

        const handleOpenConfirmation = (categoryId) => {
          setCategoryToDelete(categoryId);
          setShow(true);
      };
      
      const handleCloseConfirmation= ()=>{
          setShow(false)
        };
        const handleDelete = async () => {
          const token = localStorage.getItem('token');
          setIsLogin(true);
          try {
              await axios.delete(`${var_api}/api/category-master/delete/${categoryToDelete}`, {
                  headers: {
                      'Authorization': `${token}`
                  }
              });
              console.log('Role deleted successfully!');
              fetchData();
              handleCloseConfirmation();
              setIsLogin(false);
          } catch (error) {
              console.error('Error deleting role:', error);
              if (error.response && error.response.status === 401) {
                  history.push('/signin');
              }
          }
      };
      const handleSearchInput = (e) => {
        setSearchQuery(e.target.value)
        };
        const filteredOrders = Array.isArray(categories) && categories.filter((order)=> {
            const searchLower = searchQuery.toLowerCase();
            return(
                (order.category_name && order.category_name.toString().toLowerCase().includes(searchLower)) ||
                (order.description && order.description.toString().toLowerCase().includes(searchLower))
            )
        });

        //go to home
        const handleGoToHome = () => {
          history.push('/sb-home');
        }

    return(
        <>
        {isLogin && <Loader />}
        {/* <h1>{shopName}</h1> */}
        {/* <Header onSearchChange={handleSearchChange}  /> */}
        <Navbar bg="light" expand="md" className="bg-body-tertiary" collapseOnSelect fixed="top">
  <Navbar.Brand href="#home">
    <img src={sage} alt="logo" className="img-fluid" style={{ maxWidth: "200px", margin: "3px 80px" }} />
  </Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
    <Nav className="fw-bolder fs-5">
      <Nav.Link href="#home">
        <button type="button" className="btn btn-md" id="servicecategory" onClick={handleAdd}>
          <i className="bi bi-plus-square" style={{ color: "white", border: "none" }}>{" "} Add Category</i>
        </button>
      </Nav.Link>
    </Nav>
    <Nav className="ms-auto">
      <Nav.Link onClick={handleGoToHome} style={{ color: "black", fontSize: "15px" }}>
        <button className="btn" id="servicehomecate">
          <i className="bi bi-house"></i> Go to home
        </button>
      </Nav.Link>
    </Nav>
  </Navbar.Collapse>
</Navbar>


        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <h5 ><span id="servcateheading" >Service Categories</span>
        <span style={{float:"right",padding:"10px"}}> <Form.Control type="text" placeholder="Search..." onChange={handleSearchInput}/></span><br/>
        </h5>
        <br/>
        
        <span style={{padding:"5px 50px", fontSize:"20px"}}>Categories Count: {categories.length}</span>
       
        <div id="catediv">
      <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4 row-cols-xl-5 g-3" style={{margin:"auto"}}>
      {filteredOrders.length > 0 ? (
            filteredOrders.map((category, index) => (
              <div className="col mb-0 ftco-animate" key={category.id}>
                <div className="card" id="servcatecard" onClick={() => handleCardClick(category)}>
                  <Link to='/sub-category'>
                    <img src={`${var_api}/${category.category_image}`} alt={category.name} name='image' id="cateimg" />
                  </Link>
                  <div>
                    <div className="text py-1">
                      <h3 className="mt-1" id="marcate">
                        {category.category_name}
                        <br />
                        <span style={{ fontSize: "10px", color: "black" }}>{category.description}</span>
                        <span style={{ float: "right", fontSize: "20px", color: "red", marginRight: "2px" }}>
                          <i className="bi bi-pencil-square" style={{ color: "blue" }} onClick={() => handleEdit(category)}></i>
                          {/* <i className="bi bi-trash" onClick={() => handleOpenConfirmation(category.id)}></i> */}
                        </span>
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12">
              <p className="text-center">No data available</p>
            </div>
          )}
        <br/>
      </div>
    </div>
    <Modal
        show={show}
        onHide={handleCloseConfirmation}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
        style={{ borderRadius: '20px' }} // Add border radius style
      >
        <Modal.Header closeButton style={{backgroundColor:"rgba(103, 120, 95, 0.367)",padding:"12px"}}>
          <Modal.Title  style={{fontFamily:"serif",fontWeight:"bolder",marginLeft:"190px"}}>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>

         <div style={{padding:"20px",backgroundColor:"white"}}>
          <h6 className='text-dark' style={{textAlign:"center",fontWeight:"bolder"}}>Are You Sure You want to Delete ?</h6> 
         </div>
         {' '} 
          <Button variant="danger" style={{float:"right"}} onClick={handleCloseConfirmation}>
            Close
          </Button>{' '} 
          <Button variant="success" style={{float:"right",marginRight:"5px"}} onClick={handleDelete}>
            Confirm
          </Button>
        </Modal.Body>
      </Modal>
        </>
    );
}

export default ServiceCategory;


